import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        d: "M22.783 23.283a.75.75 0 0 1-1.061 0l-1.907-1.903a3.75 3.75 0 1 1 1.065-1.065l1.903 1.903a.75.75 0 0 1 0 1.065M17.75 20.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5",
        class: "fill-[#1A56DB] group-hover:fill-white"
      }),
      _createElementVNode("path", {
        d: "M17.25 3.5h2.25A1.5 1.5 0 0 1 21 5v9l-1.5-.75V9.5h-15V20h8.063l.562 1.5H4.5A1.5 1.5 0 0 1 3 20V5a1.5 1.5 0 0 1 1.5-1.5h2.25v-.75a.75.75 0 0 1 1.5 0v.75h7.5v-.75a.75.75 0 1 1 1.5 0zM6.75 5.75V5H4.5v3h15V5h-2.25v.75a.75.75 0 1 1-1.5 0V5h-7.5v.75a.75.75 0 0 1-1.5 0m6.185 7.75a1.125 1.125 0 1 0-1.87-1.25 1.125 1.125 0 0 0 1.87 1.25M8.81 17.25A1.125 1.125 0 1 0 6.94 16a1.125 1.125 0 0 0 1.87 1.25m.064-3.75a1.125 1.125 0 1 0-1.87-1.25 1.125 1.125 0 0 0 1.87 1.25",
        class: "fill-current group-hover:fill-white"
      })
    ], -1)
  ])))
}
export default { render: render }